'use client';

import { ReactNode, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalContext } from '../../contexts/modal-provider';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const CardModal = ({ children, id }: { children: ReactNode; id: string }) => {
  const { closeModal } = useContext(ModalContext);
  return (
    <div
      id={id}
      tabIndex={-1}
      className={`dark fixed inset-0 z-50 mx-auto flex min-h-screen w-full items-center justify-center overflow-y-auto overflow-x-hidden bg-neutral-800 bg-opacity-50 p-4 backdrop-blur`}
    >
      <div className="relative w-full max-w-[35rem]">
        <div className="relative rounded-lg bg-white p-5 shadow dark:bg-slate-800 dark:text-white">
          <div className="grid grid-cols-1">
            <button
              className="absolute right-4 top-4 z-50 flex rounded-full border-none bg-[#F38F2E] p-[6px]"
              onClick={() => closeModal()}
            >
              <FontAwesomeIcon icon={faTimes} color="white" className="!h-[18px] !w-[18px]" />
            </button>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardModal;
